<template>
    <div class="step-subcription-root">
        <!-- CONTACT DIALOG -->
        <!-- TODO: if used again, need switch el-dialog to SlsyDialog -->
        <el-dialog
            v-if="contactDialog"
            v-loading="loadingContactDialog"
            :modelValue="true"
            :fullscreen="true"
            width="100%"
            :beforeClose="closeBillingContactForm"
        >
            <header class="mb-5 p-6">
                <div class="round-64 relative dinlineb valign-middle primary-50-bkg">
                    <i class="fab fa-sellsy absolute-center white" style="font-size: 26px"></i>
                </div>
                <div class="dinlineb valign-middle ml-3">
                    <h2 class="m-0 mb-2 dinlineb">{{ $l10n.__('Abonnement Sellsy') }}</h2>
                    <a
                        href="javascript:;"
                        class="link block semibold"
                        @click="contactDialog = false"
                        ><i class="icon-arrow-back mr-1"></i>{{ $l10n.__('Retour') }}</a
                    >
                </div>
            </header>

            <div class="container-tiny m-auto">
                <h2 v-if="$slots['header'] != ''" class="mt-0">
                    {{ $filters.capitalize($l10n.__('informations de contact')) }}
                </h2>

                <p class="gray-60">
                    {{
                        $filters.capitalize(
                            $l10n.__(
                                "définissez l'ensemble des informations manquantes à la facturation.",
                            ),
                        )
                    }}
                </p>

                <div>
                    <h4>{{ $filters.capitalize($l10n.__('contact')) }}</h4>

                    <el-form
                        ref="billingContactForm"
                        :model="billingContactTmp"
                        labelPosition="top"
                        :inlineMessage="true"
                        :rules="samBillingContactRules"
                    >
                        <el-form-item
                            :label="$t.__('common.labels.first_name')"
                            prop="contactFirstName"
                            :error="errors.get('contactFirstName')"
                        >
                            <TextInput v-model="billingContactTmp.contactFirstName" mode="edit" />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.name')"
                            prop="contactName"
                            :error="errors.get('contactName')"
                        >
                            <TextInput v-model="billingContactTmp.contactName" mode="edit" />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.email_address')"
                            prop="contactEmail"
                            :error="errors.get('contactEmail')"
                        >
                            <TextInput
                                v-model="billingContactTmp.contactEmail"
                                type="email"
                                mode="edit"
                            />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.phone')"
                            prop="contactPhone"
                            :error="errors.get('contactPhone')"
                        >
                            <tel-input
                                v-model="billingContactPhoneTmp"
                                mode="edit"
                                @change="updateBilligContactPhoneTmp"
                            />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.invoicing_language')"
                            prop="locale"
                            :error="errors.get('locale')"
                        >
                            <SelectInput
                                v-model="billingContactTmp.locale"
                                mode="edit"
                                :options="billingLocales"
                                labelColumn="name"
                                idColumn="code"
                                :filterable="true"
                                class="m-0"
                            />
                        </el-form-item>

                        <el-form-item
                            :rules="additionalEmailRecipientsRules"
                            :label="$t.__('common.labels.offer_recipient_emails')"
                            prop="additionalEmailRecipients"
                            :error="errors.get('additionalEmailRecipients')"
                        >
                            <el-select
                                v-model="billingContactTmp.additionalEmailRecipients"
                                multiple
                                filterable
                                defaultFirstOption
                                allowCreate
                                :collapseTags="false"
                                popperClass="hidden"
                                :placeholder="$t.__('common.actions.search_email')"
                                class="wp-10 no-caret"
                            >
                            </el-select>
                        </el-form-item>

                        <div class="mt-6 aright">
                            <CompassButton
                                :label="$filters.capitalize($t.__('common.actions.cancel'))"
                                type="secondary"
                                @click="contactDialog = false"
                            />
                            <CompassButton
                                :label="
                                    $filters.capitalize(
                                        $t.__(
                                            'sellsyaccountmanager.subscriptionform.StepSubscription.save_contact_informations',
                                        ),
                                    )
                                "
                                type="primary"
                                @click="submitForm('billingContactForm', 'saveBillingContact')"
                            />
                        </div>
                    </el-form>
                </div>
            </div>
        </el-dialog>

        <!--  ADDRESS DIALOG -->
        <el-dialog
            v-if="addressDialog"
            v-loading="loadingAddressDialog"
            :modelValue="true"
            :fullscreen="true"
            width="100%"
            :beforeClose="closeBillingAddressForm"
        >
            <header class="mb-5 p-6">
                <div class="round-64 relative dinlineb valign-middle primary-50-bkg">
                    <i class="fab fa-sellsy absolute-center white" style="font-size: 26px"></i>
                </div>
                <div class="dinlineb valign-middle ml-3">
                    <h2 class="m-0 mb-2 dinlineb">{{ $l10n.__('Abonnement Sellsy') }}</h2>
                    <a
                        href="javascript:;"
                        class="link block semibold"
                        @click="addressDialog = false"
                        ><i class="icon-arrow-back mr-1"></i>{{ $l10n.__('Retour') }}</a
                    >
                </div>
            </header>

            <div class="container-tiny m-auto">
                <h2 v-if="$slots['header'] != ''" class="mt-0">
                    {{ $filters.capitalize($l10n.__('informations de facturation')) }}
                </h2>

                <p class="gray-60">
                    {{
                        $filters.capitalize(
                            $l10n.__(
                                "définissez l'ensemble des informations manquantes à la facturation",
                            ),
                        )
                    }}
                </p>

                <div>
                    <h4>{{ $filters.capitalize($l10n.__('adresse de facturation')) }}</h4>

                    <el-form
                        ref="billingAddressForm"
                        :model="billingAddressTmp"
                        labelPosition="top"
                        :inlineMessage="true"
                        :rules="samBillingAddressAndIntraVatRules"
                    >
                        <el-form-item
                            :label="$t.__('common.labels.street_name')"
                            prop="line1"
                            :error="errors.get('line1')"
                        >
                            <algolia-places
                                :defaultValue="billingAddressTmp.line1"
                                :templates="{
                                    value: (suggestion) => {
                                        return suggestion.name;
                                    },
                                }"
                                @bubble-address="captureAddress"
                            ></algolia-places>
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.more_address_informations')"
                            prop="line2"
                            :error="errors.get('line2')"
                        >
                            <TextInput v-model="billingAddressTmp.line2" mode="edit" />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.postal_code')"
                            prop="postalCode"
                            :error="errors.get('postalCode')"
                        >
                            <TextInput v-model="billingAddressTmp.postalCode" mode="edit" />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.city')"
                            prop="city"
                            :error="errors.get('city')"
                        >
                            <TextInput v-model="billingAddressTmp.city" mode="edit" />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.state')"
                            prop="state"
                            :error="errors.get('state')"
                        >
                            <TextInput v-model="billingAddressTmp.state" mode="edit" />
                        </el-form-item>

                        <el-form-item
                            :label="$t.__('common.labels.country')"
                            prop="country"
                            :error="errors.get('country')"
                        >
                            <SelectInput
                                v-model="billingAddressTmp.country"
                                mode="edit"
                                :options="countries"
                                labelColumn="name"
                                idColumn="code"
                                :filterable="true"
                            />
                        </el-form-item>

                        <div v-if="hasCountryIntraVat(billingAddressTmp.country)">
                            <p class="mt-4">
                                {{
                                    $l10n.__(
                                        'Entrez votre numéro de TVA intracommunautaire ci-dessous pour être facturé en franchise de TVA.',
                                    )
                                }}
                            </p>
                            <el-form-item
                                :label="$t.__('common.labels.tax_number')"
                                prop="vatIdentificationNumber"
                                :error="errors.get('vatIdentificationNumber')"
                            >
                                <TextInput
                                    v-model="billingAddressTmp.vatIdentificationNumber"
                                    mode="edit"
                                />
                            </el-form-item>
                        </div>

                        <div class="mt-6 aright">
                            <CompassButton
                                :label="$filters.capitalize($t.__('common.actions.cancel'))"
                                type="secondary"
                                @click="addressDialog = false"
                            />
                            <CompassButton
                                :label="$filters.capitalize($t.__('common.actions.save'))"
                                type="primary"
                                @click="
                                    submitForm(
                                        'billingAddressForm',
                                        'saveBillingAddressAndVatIdentificationNumber',
                                    )
                                "
                            />
                        </div>
                    </el-form>
                </div>
            </div>
        </el-dialog>

        <div class="flex-level">
            <h1 class="flex-1 m-0">{{ $filters.capitalize($l10n.__('votre abonnement')) }}</h1>
            <span v-if="isCartLoaded" class="flex-right semibold">{{
                $filters.capitalize(
                    $l10n.__('cette offre expire le %(expiration_date)s', {
                        expiration_date: $filters.dateFormatter(
                            cartExpiredDateObj.unix(),
                            'NORMAL_DATE',
                            false,
                        ),
                    }),
                )
            }}</span>
        </div>

        <!-- Subscription form -->
        <el-form
            ref="subscriptionForm"
            labelPosition="top"
            :inline="false"
            :inlineMessage="true"
            :model="subscription"
        >
            <!-- INFORMATIONS -->
            <h2 class="mt-3">{{ $filters.capitalize($l10n.__('vos informations')) }}</h2>

            <div class="flex-level flex-row">
                <div class="well flex-column flex-item-50 mr-3 pb-5 relative">
                    <h4 class="mt-0">{{ $filters.capitalize($l10n.__('contact')) }}</h4>
                    <div>
                        <p class="m-0">
                            {{ billingContact.contactName }} {{ billingContact.contactFirstName }}
                        </p>
                        <p class="m-0">{{ billingContact.contactEmail }}</p>
                        <p class="m-0">{{ billingContact.contactPhone }}</p>
                        <p v-if="billingContact.locale" class="m-0">
                            {{
                                $filters.capitalize(
                                    $l10n.__('Langue de facturation : %(billing_locale)s', {
                                        billing_locale: billingLocale.name || '',
                                    }),
                                )
                            }}
                        </p>
                        <p class="m-0 flex-column">
                            <span
                                v-for="(email, index) in billingSettings.additionalEmailRecipients"
                                :key="index"
                                >{{ email }}</span
                            >
                        </p>
                    </div>
                    <div v-if="!isBillingContactValid">
                        <p class="italic red">{{ $l10n.__('Informations manquantes') }}</p>
                    </div>
                    <a class="link absolute bottom-2 left-3" @click="editBillingContact">{{
                        $filters.capitalize($l10n.__('modifier'))
                    }}</a>
                </div>
                <div class="well flex-column flex-item-50 pb-5 relative">
                    <h4 class="mt-0">
                        {{ $filters.capitalize($l10n.__('adresse de facturation')) }}
                    </h4>
                    <div>
                        <p v-if="!billingSettings.saasThirdPartyPayerName" class="m-0">
                            {{ customer.name }}
                        </p>
                        <p v-else class="m-0">{{ billingSettings.saasThirdPartyPayerName }}</p>
                        <p v-if="!billingAddress.line1" class="italic red">
                            {{ $l10n.__('Informations manquantes') }}
                        </p>
                        <p class="m-0">{{ billingAddress.line1 }}</p>
                        <p v-if="billingAddress.line2" class="m-0">{{ billingAddress.line2 }}</p>
                        <p class="m-0">
                            {{ billingAddress.postalCode }} {{ billingAddress.city }} -
                            {{ country.name }}
                        </p>
                        <p v-if="hasCountryIntraVat(billingAddress.country)" class="m-0">
                            {{
                                $filters.capitalize(
                                    $l10n.__('n°- de TVA : %(vat_identifier)s', {
                                        vat_identifier:
                                            billingSettings.vatIdentificationNumber || '',
                                    }),
                                )
                            }}
                        </p>
                    </div>
                    <a class="link absolute bottom-2 left-3" @click="editBillingAddress">{{
                        $filters.capitalize($l10n.__('modifier'))
                    }}</a>
                </div>
            </div>

            <!-- PAIEMENT -->
            <h2 class="mt-3">{{ $filters.capitalize($l10n.__('Choix du paiement')) }}</h2>

            <div>
                <el-form-item
                    v-if="!isCartContext('upsale')"
                    prop="pricingPlan"
                    :error="errors.get('pricingPlan')"
                >
                    <RadioInput
                        v-model="pricingPlanTmp"
                        :mode="canPricingPlanBeModified ? 'edit' : 'read'"
                        radioStyle="button"
                        :choices="pricingPlansChoices"
                        class="el-radio-full-width"
                        @change="[switchCartItemPricing($event), switchPricingPlan($event)]"
                    />
                </el-form-item>
                <div v-else>
                    <div class="well py-4 acenter semibold">
                        {{
                            $filters.capitalize(
                                pricingPlansChoices.find((c) => c.value == currentPricingPlan)
                                    .label,
                            )
                        }}
                    </div>
                </div>
            </div>

            <el-alert
                v-if="isCartLoaded"
                :title="
                    $t.__(
                        'sellsyaccountmanager.subscriptionform.StepSubscription.your_cart_was_made_by_our_sale',
                    )
                "
                :closable="false"
                type="error"
                class="mt-4"
            >
            </el-alert>

            <!-- ABONNEMENT -->
            <h2 class="mt-3">{{ $filters.capitalize($l10n.__('licence')) }}</h2>

            <p v-if="!isCartContext('new') && !isCartContext('legacy_renew')">
                {{
                    $l10n.__(
                        "Vous pouvez faire évoluer votre abonnement en augmentant votre nombre d'utilisateurs et sélectionner un nouvel outil pour améliorer votre productivité !",
                    )
                }}
            </p>

            <div v-if="pricingProducts.length">
                <div class="well py-4 px-0">
                    <el-form-item
                        prop="nbLicences"
                        class="px-5 pb-2"
                        :error="errors.get('nbLicences')"
                    >
                        <h2 class="my-0 flex-level">
                            {{ $filters.capitalize($l10n.__("nombre d'utilisateurs")) }} :
                            <span v-if="cartBasicProduct.customPricing" class="flex-right"
                                >{{
                                    formatAmount(
                                        getPricingByPlan(basicCustomPricing[0].unit_amount),
                                    )
                                }}
                                {{ $l10n.__('par utilisateur / mois') }}</span
                            >
                            <span v-else class="flex-right"
                                >{{
                                    formatAmount(
                                        getPricingByPlan(
                                            getProductMonthlyAmount(
                                                pricingBasicProduct,
                                                currentPricingPlan,
                                            ),
                                        ),
                                    )
                                }}
                                {{ $l10n.__('par utilisateur / mois') }}</span
                            >
                        </h2>
                        <span
                            v-if="
                                basicCustomPricing.length &&
                                getPricingByPlan(basicCustomPricing[0].unit_amount) !==
                                    getPricingByPlan(
                                        getProductMonthlyAmount(
                                            pricingBasicProduct,
                                            currentPricingPlan,
                                            false,
                                        ),
                                    )
                            "
                            class="flex-level"
                        >
                            <span class="flex-right gray-60 fs-3 regular">
                                {{
                                    $filters.capitalize(
                                        $l10n.__(
                                            'au lieu de %(amount_f)s par utilisateur par mois',
                                            {
                                                amount_f: formatAmount(
                                                    getPricingByPlan(
                                                        getProductMonthlyAmount(
                                                            pricingBasicProduct,
                                                            currentPricingPlan,
                                                            false,
                                                        ),
                                                    ),
                                                ),
                                            },
                                        ),
                                    )
                                }}
                            </span>
                        </span>

                        <div class="flex-row ai-center mt-4">
                            <el-slider
                                v-if="tmpNbMinLicenses !== 0"
                                :marks="minimalSliderMark"
                                :modelValue="0"
                                disabled
                                class="w-100 slider-free"
                            ></el-slider>
                            <SliderInput
                                v-if="basicCustomPricing.length"
                                :modelValue="nbLicences"
                                :mode="
                                    canProductBeToggled(pricingBasicProduct, true) ? 'edit' : 'read'
                                "
                                :min="tmpNbMinLicenses"
                                :max="Math.max(maxNbLicences, tmpNbLicenses)"
                                :marks="{
                                    tmpNbMinLicenses: tmpNbMinLicenses.toString(),
                                    500: '500',
                                }"
                                showInput
                                :class="{
                                    'ml-1 wp-10 slider-priced': true,
                                    'is-max-range':
                                        tmpNbMinLicenses === Math.max(maxNbLicences, tmpNbLicenses),
                                }"
                                @update:modelValue="updatePricingStep"
                            />
                            <SliderInput
                                v-else
                                :mode="
                                    canProductBeToggled(pricingBasicProduct, true) ? 'edit' : 'read'
                                "
                                :modelValue="tmpNbLicenses"
                                :min="tmpNbMinLicenses"
                                :max="Math.max(maxNbLicences, tmpNbLicenses)"
                                :marks="{
                                    tmpNbMinLicenses: tmpNbMinLicenses.toString(),
                                    500: '500',
                                }"
                                showInput
                                :class="{
                                    'ml-1 wp-10 slider-priced': true,
                                    'is-max-range':
                                        tmpNbMinLicenses === Math.max(maxNbLicences, tmpNbLicenses),
                                }"
                                @update:modelValue="updateNbLicenses"
                            />
                        </div>
                    </el-form-item>

                    <div v-if="cartBasicProduct.length > 1" class="bt-1 px-5 py-2">
                        <h2 class="mb-0">{{ $l10n.__('Inclus') }}</h2>
                        <template v-for="(pricing, index) of basicCustomPricing" :key="index">
                            <p v-if="pricing.unit_amount === 0" class="flex-level jc-space">
                                <span class="grey semibold">{{
                                    $l10n.n__(
                                        'Utilisateur offert',
                                        'Utilisateurs offerts',
                                        cartNbOfferedLicenses,
                                        { users: cartNbOfferedLicenses },
                                    )
                                }}</span>
                                <span class="semibold">{{
                                    $l10n.n__(
                                        '%(users)s utilisateur offert',
                                        '%(users)s utilisateurs offerts',
                                        cartNbOfferedLicenses,
                                        { users: cartNbOfferedLicenses },
                                    )
                                }}</span>
                            </p>

                            <p v-else-if="index !== 0" class="flex-level jc-space">
                                <span class="grey semibold">{{
                                    $l10n.n__(
                                        'Utilisateur à tarif préférentiel',
                                        'Utilisateurs à tarif préférentiel',
                                        pricing.nbLicences,
                                    )
                                }}</span>
                                <span class="semibold">{{
                                    $l10n.n__(
                                        '%(users)s utilisateur à %(amount)s / mois / utilisateur',
                                        '%(users)s utilisateurs à %(amount)s / mois / utilisateur',
                                        pricing.nbLicences,
                                        {
                                            amount: formatAmount(
                                                getPricingByPlan(pricing.unit_amount),
                                            ),
                                            users: pricing.nbLicences,
                                        },
                                    )
                                }}</span>
                            </p>
                        </template>
                    </div>
                    <div class="bt-1 px-5 py-2 flex-level">
                        <h2 class="my-0 fs-4">{{ $l10n.__('Total') }}</h2>
                        <div class="flex-column flex-item-right aright">
                            <p class="semibold fs-4">
                                {{
                                    $l10n.n__(
                                        '%s utilisateur',
                                        '%s utilisateurs',
                                        totalTmpNbLicences,
                                        totalTmpNbLicences,
                                    )
                                }}
                            </p>
                            <span>{{
                                $l10n.__(
                                    'Soit %s / mois (remises comprises)',
                                    formatAmount(totalOnlyUsersLicences),
                                )
                            }}</span>
                        </div>
                    </div>
                </div>

                <!-- Plugins -->
                <h2 class="mt-3">{{ $filters.capitalize($l10n.__('outils')) }}</h2>
                <div class="well mt-4 p-5">
                    <ul class="m-0">
                        <li class="pb-5 flex-level">
                            <h3 class="flex m-0 mr-3">{{ pricingBasicProduct.printableName }}</h3>
                            <div class="flex-3 gray-60">
                                {{ pricingBasicProduct.printableShortDescription }}
                                <a
                                    v-if="
                                        pricingBasicProduct.frontUrlDescription &&
                                        pricingBasicProduct.frontUrlDescription != ''
                                    "
                                    class="link"
                                    :href="pricingBasicProduct.frontUrlDescription"
                                    target="_blank"
                                    >{{ $l10n.__('En savoir plus') }}</a
                                >
                            </div>
                            <h2 class="flex-3 aright m-0">
                                {{ $filters.capitalize($l10n.__('inclus')) }}
                            </h2>
                        </li>
                        <li
                            v-for="quota in quotasByCountryCodeAndPlan"
                            :key="quota.code"
                            class="pb-5 flex-level"
                        >
                            <span class="flex m-0 mr-3">&nbsp;</span>
                            <div class="flex-3 gray-60">
                                {{ quotaPrintableDescription(quota, currentPricingPlan) }}
                            </div>
                            <h2 class="flex-3 aright m-0">
                                {{ $filters.capitalize($l10n.__('inclus')) }}
                            </h2>
                        </li>
                        <li
                            v-for="product in pricingOptionalProductsSubscribableByCustomer"
                            :key="product.code"
                            class="bt-1 py-5 flex-level"
                        >
                            <h3 class="flex m-0 mr-3">{{ product.printableName }}</h3>
                            <div class="flex-3 gray-60">
                                {{ product.printableShortDescription }}
                                <a
                                    v-if="
                                        product.frontUrlDescription &&
                                        product.frontUrlDescription != ''
                                    "
                                    class="link"
                                    :href="product.frontUrlDescription"
                                    target="_blank"
                                    >{{ $l10n.__('En savoir plus') }}</a
                                >
                            </div>
                            <div class="flex-2 aright m-0">
                                <h2 class="dinlineb m-0">
                                    {{
                                        formatAmount(
                                            getPricingByPlan(
                                                getProductMonthlyAmount(
                                                    product,
                                                    currentPricingPlan,
                                                ),
                                            ),
                                        )
                                    }}
                                </h2>
                                <span class="grey fs-3 regular">/ {{ $l10n.__('mois') }}</span>

                                <span
                                    v-if="
                                        getProductMonthlyAmount(product, currentPricingPlan) !==
                                        getProductMonthlyAmount(product, currentPricingPlan, false)
                                    "
                                    class="block gray-60 fs-3 regular"
                                >
                                    {{
                                        $filters.capitalize(
                                            l10n.__('au lieu de %(amount_f)s', {
                                                amount_f: formatAmount(
                                                    getPricingByPlan(
                                                        getProductMonthlyAmount(
                                                            product,
                                                            currentPricingPlan,
                                                            false,
                                                        ),
                                                    ),
                                                ),
                                            }),
                                        )
                                    }}
                                    / {{ $l10n.__('mois') }}
                                </span>
                            </div>
                            <div class="flex aright">
                                <el-switch
                                    :modelValue="!!getCartItem(product.id)"
                                    :disabled="!canProductBeToggled(product, false)"
                                    @change="toggleItem(product)"
                                />
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- UPSALE - AMOUNT DIFFS -->
                <div
                    v-if="
                        !isCartContext('new') &&
                        !isCartContext('legacy_renew') &&
                        isCurrentPricingMonthly
                    "
                    class="mt-4 my-2 flex-level semibold"
                >
                    <span class="m-0 flex-right flex-3 aright">
                        {{
                            $filters.capitalize(
                                $l10n.__('Total supplémentaire sur votre abonnement'),
                            )
                        }}
                    </span>
                    <span class="flex-right flex-1 aright">
                        <span
                            v-if="
                                newItemsOnSubscriptionTotalForCurrentPricingPlan.totalDiscounted > 0
                            "
                            >+ </span
                        >{{
                            formatAmount(
                                newItemsOnSubscriptionTotalForCurrentPricingPlan.totalDiscounted,
                            )
                        }}
                        {{ $l10n.p__('without_tax_acronym', 'HT') }} /
                        {{ $filters.capitalize($l10n.__('mois')) }}
                    </span>
                </div>

                <!-- UNDER LINE SUM -->
                <!-- MONTHLY -->
                <div v-if="isCurrentPricingMonthly" class="mt-4">
                    <!-- NEW -->
                    <div v-if="!isCartContext('upsale')">
                        <h2 class="wp-6 flex-level flex-item-right mb-1">
                            {{ $filters.capitalize($l10n.__('total mensuel HT')) }}
                            <span class="fs-4 flex-right"
                                >{{ formatAmount(currentPricingTotal.totalDiscounted) }} /
                                {{ $l10n.__('mois') }}</span
                            >
                        </h2>
                        <p v-if="cartHasDiscount" class="my-1 wp-6 flex-level flex-item-right">
                            {{ $filters.capitalize($l10n.__('Dont remise mensuelle')) }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(currentPricingTotal.discount)
                            }}</span>
                        </p>
                        <p
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            {{ $l10n.__('TVA') }} ({{ currentCountryTaxRate * 100 }}%)
                            <span class="fs-3 flex-right"
                                >{{ formatAmount(currentPricingTotal.tax, true) }}
                            </span>
                        </p>
                        <p
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            {{ $filters.capitalize($l10n.__('total mensuel TTC')) }}
                            <span class="fs-3 flex-right"
                                >{{ formatAmount(currentPricingTotal.totalTaxIncluded, true) }}
                            </span>
                        </p>
                        <h2 class="my-1 wp-6 flex-level flex-item-right">
                            <span class="fs-3 flex-right">{{
                                $l10n.__('Engagement sur 12 mois')
                            }}</span>
                        </h2>
                        <p
                            v-if="deadlines.length > 0"
                            class="my-1 wp-6 flex-level flex-item-right semibold"
                        >
                            <span class="fs-3">
                                {{ $filters.capitalize($l10n.__('échéancier')) }}
                            </span>
                        </p>
                        <p v-if="cartEarlyRenewal" class="my-1 wp-6 flex-level flex-item-right">
                            {{ $filters.capitalize($l10n.__('Restant à consommer')) }}
                            <span class="fs-3 flex-right">
                                {{
                                    formatAmount(
                                        -1 * centsToCurrency(cartEarlyRenewalDiscount),
                                        true,
                                    )
                                }}
                            </span>
                        </p>
                        <p
                            v-for="deadline in deadlines"
                            :key="deadline.key"
                            class="my-1 wp-6 flex-level flex-item-right gray-60"
                        >
                            {{ $filters.dateFormatter(deadline.date.unix(), 'NORMAL_DATE', false) }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(deadline.amount, true)
                            }}</span>
                        </p>
                        <p
                            v-if="deadlineUnchanged > 0 && deadlineUnchanged < 12"
                            class="my-1 wp-6 flex-level flex-item-right gray-60"
                        >
                            {{
                                $l10n.__('%(deadlineUnchanged)s échéances suivantes', {
                                    deadlineUnchanged: deadlineUnchanged,
                                })
                            }}
                            <span class="fs-3 flex-right">
                                {{ formatAmount(currentPricingTotal.totalTaxIncluded, true) }}
                            </span>
                        </p>
                    </div>
                    <!-- UPSALE -->
                    <div v-else>
                        <div class="my-2 flex-level fs-4 bold">
                            <span class="m-0 flex-right flex-3 aright">
                                {{
                                    $filters.capitalize(
                                        $l10n.__('total mensuel HT de votre abonnement'),
                                    )
                                }}
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{ formatAmount(currentPricingTotal.totalDiscounted) }} /
                                {{ $filters.capitalize($l10n.__('mois')) }}
                            </span>
                        </div>

                        <div v-if="cartHasDiscount" class="my-2 flex-level semibold gray-60">
                            <span class="m-0 flex-right flex-3 aright semibold gray-60">
                                {{ $l10n.__('Dont remise mensuelle') }} ({{
                                    currentCountryTaxRate * 100
                                }}%)
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{ formatAmount(currentPricingTotal.discount) }} /
                                {{ $filters.capitalize($l10n.__('mois')) }}
                            </span>
                        </div>

                        <div
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-2 flex-level semibold gray-60"
                        >
                            <span class="m-0 flex-right flex-3 aright semibold gray-60">
                                {{ $l10n.__('TVA') }} ({{ currentCountryTaxRate * 100 }}%)
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{ formatAmount(currentPricingTotal.tax, true) }} /
                                {{ $filters.capitalize($l10n.__('mois')) }}
                            </span>
                        </div>

                        <div
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-2 flex-level semibold gray-60"
                        >
                            <span class="m-0 flex-right flex-3 aright semibold gray-60">
                                {{ $filters.capitalize($l10n.__('total mensuel TTC')) }}
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{ formatAmount(currentPricingTotal.totalTaxIncluded, true) }} /
                                {{ $filters.capitalize($l10n.__('mois')) }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- YEARLY -->
                <div v-else class="mt-4">
                    <!-- NEW -->
                    <div v-if="!isCartContext('upsale')">
                        <p
                            v-if="!cartHasDiscount"
                            class="my-1 wp-6 flex-level flex-item-right gray-60"
                        >
                            {{
                                $filters.capitalize(
                                    $l10n.__(
                                        'Économie réalisée en payant mon abonnement en une fois',
                                    ),
                                )
                            }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(diffMonthlyYearly)
                            }}</span>
                        </p>
                        <p
                            v-if="isPaymentFacilityEnabled"
                            class="my-1 wp-6 flex-level flex-item-right gray-60"
                        >
                            {{
                                $filters.capitalize(
                                    $l10n.__('Paiement en %s fois activé', cartPaymentFacility),
                                )
                            }}
                        </p>
                        <p
                            v-if="isCustomPaymentFacilityEnabled"
                            class="my-1 wp-6 flex-level flex-item-right gray-60"
                        >
                            {{
                                $filters.capitalize(
                                    $l10n.__('Paiement en %s fois activé', cartNbCustomFacilities),
                                )
                            }}
                        </p>

                        <p v-if="cartEarlyRenewal" class="my-1 wp-6 flex-level flex-item-right">
                            {{ $filters.capitalize($l10n.__('Montant HT')) }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(currentPricingTotal.totalWithCutomPricingYearly)
                            }}</span>
                        </p>

                        <p v-if="cartEarlyRenewal" class="my-1 wp-6 flex-level flex-item-right">
                            {{ $filters.capitalize($l10n.__('Restant à consommer')) }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(-1 * centsToCurrency(cartEarlyRenewalDiscount), true)
                            }}</span>
                        </p>

                        <h2 class="wp-6 flex-level flex-item-right mb-1">
                            {{ $filters.capitalize($l10n.__('total HT')) }}
                            <span class="fs-4 flex-right">{{
                                formatAmount(currentPricingTotal.totalDiscounted, true)
                            }}</span>
                        </h2>
                        <p v-if="cartHasDiscount" class="my-1 wp-6 flex-level flex-item-right">
                            {{ $filters.capitalize($l10n.__('Dont remise annuelle')) }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(currentPricingTotal.discount, true)
                            }}</span>
                        </p>
                        <p
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            {{ $l10n.__('TVA') }} ({{ currentCountryTaxRate * 100 }}%)
                            <span class="fs-3 flex-right">{{
                                formatAmount(currentPricingTotal.tax, true)
                            }}</span>
                        </p>
                        <p
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            {{ $filters.capitalize($l10n.__('total TTC')) }}
                            <span class="fs-3 flex-right">{{
                                formatAmount(currentPricingTotal.totalTaxIncluded, true)
                            }}</span>
                        </p>
                        <p
                            v-if="isPaymentFacilityEnabled"
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            {{
                                $filters.capitalize(
                                    $l10n.__('Paiement en %s fois', cartPaymentFacility),
                                )
                            }}
                            <span
                                v-if="cartNextAmountFacility < cartFirstAmountFacility"
                                class="fs-3 flex-right"
                            >
                                1 x {{ formatAmount(cartFirstAmountFacility, true) }}<br />
                            </span>
                            <span v-else class="fs-3 flex-right">
                                {{ cartPaymentFacility }} x
                                {{ formatAmount(cartFirstAmountFacility, true) }}
                            </span>
                        </p>
                        <p
                            v-if="
                                isPaymentFacilityEnabled &&
                                cartNextAmountFacility < cartFirstAmountFacility
                            "
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            <span class="fs-3 flex-right">
                                {{ cartPaymentFacility - 1 }} x
                                {{ formatAmount(cartNextAmountFacility, true) }}
                            </span>
                        </p>
                        <p
                            v-if="isCustomPaymentFacilityEnabled"
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            {{
                                $filters.capitalize(
                                    $l10n.__('Paiement en %s fois', cartNbCustomFacilities),
                                )
                            }}
                            <span
                                v-if="cartFirstAmountCustomFacility < cartLastAmountCustomFacility"
                                class="fs-3 flex-right"
                            >
                                {{ cartNbFirstCustomFacilities }} x
                                {{ formatAmount(cartFirstAmountCustomFacility, true) }}<br />
                            </span>
                            <span v-else class="fs-3 flex-right">
                                {{ cartNbCustomFacilities }} x
                                {{ formatAmount(cartFirstAmountFacility, true) }}
                            </span>
                        </p>
                        <p
                            v-if="
                                isCustomPaymentFacilityEnabled &&
                                cartFirstAmountCustomFacility < cartLastAmountCustomFacility
                            "
                            class="my-1 wp-6 flex-level flex-item-right"
                        >
                            <span class="fs-3 flex-right">
                                1 x {{ formatAmount(cartLastAmountCustomFacility, true) }}
                            </span>
                        </p>
                    </div>
                    <!-- UPSALE -->
                    <div v-else>
                        <div class="my-2 flex-level fs-4 bold">
                            <span class="m-0 flex-right flex-3 aright">
                                {{
                                    $filters.capitalize(
                                        $l10n.__('total HT supplémentaire estimé à payer*'),
                                    )
                                }}
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{
                                    formatAmount(
                                        newItemsOnSubscriptionTotalForCurrentPricingPlan.totalDiscounted,
                                    )
                                }}
                            </span>
                        </div>
                        <div
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-2 flex-level semibold gray-60"
                        >
                            <span class="m-0 flex-right flex-3 aright semibold gray-60">
                                {{ $l10n.__('TVA estimée') }} ({{ currentCountryTaxRate * 100 }}%)
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{
                                    formatAmount(
                                        newItemsOnSubscriptionTotalForCurrentPricingPlan.tax,
                                    )
                                }}
                            </span>
                        </div>
                        <div
                            v-if="showTaxTotal && currentCountryTaxRate > 0"
                            class="my-2 flex-level semibold gray-60"
                        >
                            <span class="m-0 flex-right flex-3 aright">
                                {{
                                    $filters.capitalize(
                                        $l10n.__('total TTC supplémentaire estimé à payer*'),
                                    )
                                }}
                            </span>
                            <span class="flex-right flex-1 aright">
                                {{
                                    formatAmount(
                                        newItemsOnSubscriptionTotalForCurrentPricingPlan.totalTaxIncluded,
                                    )
                                }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- EXPECTED START OF SUBSCRIPTION -->
            <div
                v-if="isCartContext('new') && cartPeriodStartDate"
                class="well mt-4 p-3 flex-level"
            >
                <span class="flex-1">{{ $l10n.__("Date d'activation de votre abonnement") }}:</span>
                <span class="flex-right semibold">
                    {{
                        $filters.dateFormatter(cartPeriodStartDateObj.unix(), 'NORMAL_DATE', false)
                    }}
                </span>
            </div>
            <div
                v-if="
                    (isCartContext('legacy_renew') || isCartContext('renew')) && cartPeriodStartDate
                "
                class="well mt-4 p-3 flex-level"
            >
                <span class="flex-1">
                    {{ $l10n.__('Date de renouvellement de votre abonnement') }}:</span
                >
                <span v-if="!cartEarlyRenewal" class="flex-right semibold">
                    {{
                        $filters.dateFormatter(cartPeriodStartDateObj.unix(), 'NORMAL_DATE', false)
                    }}
                </span>
                <span v-else class="flex-right semibold">
                    {{ $filters.dateFormatter(now.unix(), 'NORMAL_DATE', false) }}
                </span>
            </div>
            <!-- ACTUAL END OF SUBSCRIPTION -->
            <div
                v-else-if="!isCartContext('new') && customerServiceEndDate"
                class="well mt-4 p-4 flex-level"
            >
                <span class="flex-1">
                    {{ $l10n.__("La date de votre fin d'abonnement est le :") }}
                </span>
                <span class="flex-right semibold">
                    {{
                        $filters.dateFormatter(
                            customerServiceEndDateObj.unix(),
                            'NORMAL_DATE',
                            false,
                        )
                    }}
                </span>
            </div>

            <!-- DIRECT DEBIT SCHEDULE -->
            <div v-if="isCartContext('renew')" class="my-5 px-5 acenter">
                <p v-if="cartPaymentMethod == 'stripe_card'">
                    {{
                        $filters.capitalize(
                            $l10n.__('la facture sera éditée et prélevée le %(date)s', {
                                date: $filters.dateFormatter(
                                    cartInvoiceEditionDate.unix(),
                                    'SLASHED_DATE',
                                    false,
                                ),
                            }),
                        )
                    }}
                </p>
                <p v-else>
                    {{
                        $filters.capitalize(
                            $l10n.__('la facture sera éditée le %(date)s', {
                                date: $filters.dateFormatter(
                                    cartInvoiceEditionDate.unix(),
                                    'SLASHED_DATE',
                                    false,
                                ),
                            }),
                        )
                    }}
                </p>
            </div>

            <!-- PRORATA TEMPORIS -->
            <div v-if="isCartContext('upsale')" class="my-5 px-5">
                <p v-if="isCurrentPricingMonthly">
                    <span class="semibold">{{ $l10n.__('Attention') }} :</span>
                    {{
                        $l10n.__(
                            'La prochaine facture est calculée prorata temporis, les échéances suivantes au taux plein',
                        )
                    }}.
                </p>
                <p v-else class="my-5">
                    *
                    {{
                        $l10n.__(
                            'Ce montant est une estimation pour un prorata à cet instant. Le montant exact de la facture sera calculé au prorata du temps restant sur votre abonnement au moment du paiement.',
                        )
                    }}
                </p>
            </div>

            <!-- VALIDATE BUTTON -->
            <a
                role="button"
                class="btn btn-primary btn-block mt-5"
                :disabled="!canCartBeSaved"
                @click.prevent="canCartBeSaved ? submitForm('subscriptionForm') : ''"
            >
                {{ $filters.capitalize($l10n.__('valider mon panier')) }}
            </a>
        </el-form>
        <!-- /Subscription form -->

        <!-- Sticky -->
        <div id="sticky" class="well acenter shadow p-0">
            <div v-if="!isCartContext('upsale')">
                <!-- YOUR SUBSCRIPTION -->
                <p class="title mt-3 gray-60 m-0">
                    {{ $filters.capitalize($l10n.__('votre abonnement')) }}
                </p>

                <div class="my-3">
                    <h2 class="m-0">
                        {{
                            $l10n.n__(
                                '%(users)s utilisateur',
                                '%(users)s utilisateurs',
                                totalTmpNbLicences,
                                { users: totalTmpNbLicences },
                            )
                        }}
                    </h2>
                    <div
                        v-for="(pricing, index) of basicCustomPricing"
                        :key="index"
                        class="gray-60"
                    >
                        <span v-if="pricing.unit_amount === 0">
                            {{
                                $l10n.n__(
                                    '%(users)s utilisateur offert',
                                    '%(users)s utilisateurs offerts',
                                    cartNbOfferedLicenses,
                                    { users: cartNbOfferedLicenses },
                                )
                            }}
                        </span>
                        <span v-else>{{
                            $l10n.n__(
                                '%(users)s utilisateur : %(amount)s /mois',
                                '%(users)s utilisateurs : %(amount)s /mois',
                                pricing.nbLicences,
                                {
                                    amount: formatAmount(getPricingByPlan(pricing.unit_amount)),
                                    users: pricing.nbLicences,
                                },
                            )
                        }}</span>
                    </div>
                </div>

                <p
                    v-for="(item, index) in sortProducts(cartItemsIterable)"
                    :key="index"
                    class="m-0 semibold"
                >
                    {{ $filters.capitalize(index > 0 ? '+ ' : null) }}
                    {{ item.product.printableName }}
                </p>

                <div class="my-3">
                    <h2 class="m-0">{{ formatAmount(cartTotal.monthly.totalDiscounted) }}</h2>
                    <span class="grey regular fs-3"
                        >{{ $l10n.p__('without_tax_acronym', 'HT') }} / {{ $l10n.__('mois') }}</span
                    >
                </div>
            </div>
            <div v-else v-once>
                <!-- YOUR CURRENT SUBSCRIPTION -->
                <p class="title mt-3 gray-60 m-0">
                    {{ $filters.capitalize($l10n.__('votre abonnement actuel')) }}
                </p>

                <div class="my-3">
                    <h2 class="m-0">
                        {{
                            $l10n.n__(
                                '%(users)s utilisateur',
                                '%(users)s utilisateurs',
                                customerSubscribedLicenses,
                                { users: customerSubscribedLicenses },
                            )
                        }}
                    </h2>
                    <div
                        v-for="(pricing, index) of defineQuantityAppliedForEachPricingTier(
                            customerSubscribedBasicProductCustomPricing,
                            customerSubscribedLicenses,
                        ).reverse()"
                        :key="index"
                        class="gray-60"
                    >
                        <span v-if="pricing.unit_amount === 0">
                            {{
                                $l10n.n__(
                                    '%(users)s utilisateur offert',
                                    '%(users)s utilisateurs offerts',
                                    pricing.nbLicences,
                                    { users: pricing.nbLicences },
                                )
                            }}
                        </span>
                        <span v-else>{{
                            $l10n.n__(
                                '%(users)s utilisateur : %(amount)s /mois',
                                '%(users)s utilisateurs : %(amount)s /mois',
                                pricing.nbLicences,
                                {
                                    amount: formatAmount(getPricingByPlan(pricing.unit_amount)),
                                    users: pricing.nbLicences,
                                },
                            )
                        }}</span>
                    </div>
                </div>

                <p
                    v-for="(item, index) in sortProducts(subscribedProductsIterable)"
                    :key="index"
                    class="m-0 semibold"
                >
                    {{ $filters.capitalize(index > 0 ? '+ ' : null) }}
                    {{ item.product.printableName }}
                </p>

                <div class="my-3">
                    <h2 class="m-0">
                        {{ formatAmount(customerSubscribedTotal.monthly.totalDiscounted) }}
                    </h2>
                    <span class="grey regular fs-3"
                        >{{ $l10n.p__('without_tax_acronym', 'HT') }} / {{ $l10n.__('mois') }}</span
                    >
                </div>
            </div>

            <div v-if="isCartContext('upsale')">
                <!-- YOUR SUBSCRIPTION CHANGES -->
                <p class="title mt-3 m-0">
                    {{ $filters.capitalize($l10n.__('évolution de votre abonnement')) }}
                </p>

                <div class="my-3">
                    <h2 class="m-0">
                        {{
                            $l10n.n__(
                                '%(users)s utilisateur',
                                '%(users)s utilisateurs',
                                totalTmpNbLicences,
                                { users: totalTmpNbLicences },
                            )
                        }}
                    </h2>
                    <div v-for="(pricing, index) of basicCustomPricing" :key="index">
                        <span v-if="pricing.unit_amount === 0">
                            {{
                                $l10n.n__(
                                    '%(users)s utilisateur offert',
                                    '%(users)s utilisateurs offerts',
                                    pricing.nbLicences,
                                    { users: pricing.nbLicences },
                                )
                            }}
                        </span>
                        <span v-else>{{
                            $l10n.n__(
                                '%(users)s utilisateur : %(amount)s /mois',
                                '%(users)s utilisateurs : %(amount)s /mois',
                                pricing.nbLicences,
                                {
                                    amount: formatAmount(getPricingByPlan(pricing.unit_amount)),
                                    users: pricing.nbLicences,
                                },
                            )
                        }}</span>
                    </div>
                </div>

                <p
                    v-for="(item, index) in sortProducts(cartItemsIterable)"
                    :key="index"
                    class="m-0 semibold"
                >
                    {{ $filters.capitalize(index > 0 ? '+ ' : null) }}
                    {{ item.product.printableName }}
                </p>

                <div class="my-3">
                    <h2 class="m-0">{{ formatAmount(cartTotal.monthly.totalDiscounted) }}</h2>
                    <span class="regular fs-3"
                        >{{ $l10n.p__('without_tax_acronym', 'HT') }} / {{ $l10n.__('mois') }}</span
                    >
                </div>
            </div>
        </div>
        <!-- /Sticky -->
    </div>
</template>

<script>
import SAMMixins from '../../../mixins/subscription/SAMMixins';
import FormMixins from '../../../mixins/FormMixins';

import AlgoliaInput from '../../inputs/AlgoliaInput.vue';
import TelInput from '../../inputs/TelInput.vue';
import SliderInput from 'vcomponents/inputs/SliderInput.vue';
import RadioInput from 'vcomponents/inputs/RadioInput.vue';
import SelectInput from 'vcomponents/inputs/SelectInput.vue';
import TextInput from 'vcomponents/inputs/TextInput.vue';

import WidgetMixins from '../../../mixins/sellsyaccountmanager/widgetMixins';

export default {
    components: {
        SliderInput,
        RadioInput,
        SelectInput,
        TextInput,
        'algolia-places': AlgoliaInput,
        'tel-input': TelInput,
    },

    mixins: [SAMMixins, FormMixins, WidgetMixins],
    data() {
        return {
            contactDialog: false,
            loadingContactDialog: false,
            addressDialog: false,
            loadingAddressDialog: false,

            loadedInMixin: false,
            nbLicences: 0,
        };
    },
    computed: {
        freeStep() {
            return this.cartBasicProduct.customPricing?.find(
                (pricing) => pricing.unit_amount === 0,
            );
        },
        minimalSliderMark() {
            return {
                0:
                    _.isNil(this.cartBasicProduct.customPricing) || _.isNil(this.freeStep)
                        ? '2'
                        : this.freeStep?.nbLicences.toString(),
            };
        },
        basicCustomPricing() {
            return _.isNil(this.cartBasicProduct.customPricing)
                ? []
                : _.cloneDeep(this.cartBasicProduct?.customPricing).reverse();
        },
        totalTmpNbLicences() {
            return this.cartBasicProduct.customPricing?.length
                ? this.cartBasicProduct?.customPricing
                    .map((pricing) => pricing.nbLicences)
                    .reduce((acc, value) => acc + value)
                : this.cartNbLicenses;
        },
        now() {
            return moment();
        },
        canPricingPlanBeModified() {
            return !this.isCartLoaded && !this.isCartContext('upsale') && !this.cartHasDiscount;
        },
        pricingPlansChoices() {
            return [
                {
                    value: 'YEARLY',
                    label: this.$l10n.n__(
                        'Je paie en une fois',
                        'Je paie en %(facility)s fois',
                        this.cartNbFacilities,
                        { facility: this.cartNbFacilities },
                    ),
                    sublabel:
                        '(' +
                        this.$l10n.__('%(min)s à %(max)s de réduction', { min: 10, max: '20%' }) +
                        ')',
                },
                {
                    value: 'MONTHLY',
                    label: this.$l10n.__('Je paie tous les mois'),
                    sublabel: '(' + this.$l10n.__('Engagement sur 12 mois') + ')',
                },
            ];
        },
        isBillingContactValid() {
            return this.isContactValid(this.billingContactTmp);
        },
        isBillingAddressValid() {
            return this.isAddressValid(this.billingAddress);
        },
        quotasByCountryCode() {
            return this.getQuotasByCountryCode(this.billingAddress.country);
        },
        quotasByCountryCodeAndPlan() {
            return this.quotasByCountryCode.filter(
                (quota) => quota.quantitiesByPlan[this.currentPricingPlan] > 0,
            );
        },
        cartNbFacilities() {
            if (this.isCurrentPricingMonthly || this.isCartContext('upsale')) {
                return 1;
            }

            return this.isCustomPaymentFacilityEnabled
                ? this.cartNbCustomFacilities
                : this.cartPaymentFacility;
        },
        pricingOptionalProductsSubscribableByCustomer() {
            return [...this.pricingOptionalProducts, ...this.pricingOptionalProductsGrouped].filter(
                (product) => {
                    return product.groups.length
                        ? !!this.getCartItem(product.id)
                        : product.subscribableByCustomer ||
                              !!this.getCartItem(product.id) ||
                              this.getCustomerSubscribedProduct(product);
                },
            );
        },
        cartInvoiceEditionDate() {
            if (this.isCartContext('renew')) {
                return this.cartEarlyRenewal ? this.now : this.cartPeriodStartDateObj;
            }

            return this.cartPeriodStartDateObj || this.now;
        },
    },
    created() {
        if (this.cartBasicProduct && this.isCartLoaded) {
            // If a cart has been edited by a sales, not less than cart quantity
            this.tmpNbMinLicenses = this.cartBasicProduct.quantity;
        } else if (this.customerSubscribedLicenses) {
            // others cases (self service, upsell) : not less than subscribed licences*
            this.tmpNbMinLicenses = this.customerSubscribedLicenses;
        } // else WidgetMixins default value (2)

        this.tmpNbLicenses = this.tmpNbMinLicenses;
        if (this.cartNbLicenses) this.tmpNbLicenses = this.cartNbLicenses;
        else if (this.activeCustomerAccounts.length > this.tmpNbMinLicenses)
            this.tmpNbLicenses = this.activeCustomerAccounts.length;

        this.pricingPlanTmp = this.currentPricingPlan;

        this.initBillingContactTmp();
        this.initBillingAddressTmp();

        this.nbLicences = this.tmpNbLicenses;

        this.customerSubscribedTotal = this.buildTotal(
            this.subscribedProductsIterable,
            this.billingSettings.pricingPlanCode || this.currentPricingPlan,
        );
    },

    methods: {
        quotaPrintableDescription(quota, plan) {
            if (quota.quantitiesByPlan[plan] !== undefined) {
                return (
                    (_.isNil(quota.quantitiesByPlan[plan])
                        ? this.$l10n.__('Illimité') + ' - '
                        : quota.quantitiesByPlan[plan] + ' ') + quota.printableName
                );
            }
            return quota.printableName;
        },
        updatePricingStep(qty) {
            const customPricing = this.defineQuantityAppliedForEachPricingTier(
                this.cartBasicProduct.customPricing,
                qty,
            );
            this.updateUsersLicencesCustomPricing(this.pricingBasicProduct.id, customPricing);
        },
        centsToCurrency(cents) {
            return cents / 100;
        },
        editBillingContact() {
            this.initBillingContactTmp();
            this.contactDialog = true;
        },
        closeBillingContactForm() {
            this.loadingContactDialog = false;
            this.contactDialog = false;
            this.$emit('load', false);
        },
        saveBillingContact() {
            this.loadingContactDialog = true;

            if (!this.isContactValid(this.billingContactTmp, this.billingContactPhoneTmp)) {
                Push.error(
                    this.$l10n.__(
                        'Les informations de votre contact de facturation sont nécessaires pour la construction de votre abonnement',
                    ),
                    this.$l10n.__('Contact de facturation'),
                );
                this.loadingContactDialog = false;
                return;
            }

            return this.recordBillingContact(
                this.customerCorporation,
                this.billingContactTmp,
                this.billingContactPhoneTmp,
            )
                .then((contact) => {
                    return this.setBillingContact(contact);
                })
                .then(() => this.closeBillingContactForm());
        },
        editBillingAddress() {
            this.initBillingAddressTmp();
            this.addressDialog = true;
        },
        closeBillingAddressForm() {
            this.loadingAddressDialog = false;
            this.addressDialog = false;
            this.$emit('load', false);
        },

        saveBillingAddressAndVatIdentificationNumber() {
            this.loadingAddressDialog = true;

            if (!this.isAddressValid(this.billingAddressTmp)) {
                Push.error(
                    this.$l10n.__(
                        'Les informations de votre adresse de facturation sont insuffisantes',
                    ),
                    this.$l10n.__('Adresse de facturation'),
                );
                this.loadingAddressDialog = false;
                return;
            }

            // record both then set both
            return Promise.all([
                this.recordBillingAddress(this.customerCorporation, this.billingAddressTmp),
                this.recordBillingSettings(
                    this.customerCorporation,
                    _.merge(this.billingSettings, {
                        vatIdentificationNumber: this.billingAddressTmp.vatIdentificationNumber,
                    }),
                ),
            ])
                .then(([address, settings]) => {
                    if (address.country !== this.billingAddress.country)
                        EventBus.emit('avoidTerms');
                    return Promise.all([
                        this.setBillingAddress(address),
                        this.setBillingSettings(settings),
                    ]);
                })
                .then(() => this.closeBillingAddressForm());
        },
        save() {
            if (!this.canCartBeSaved) return;

            return this.isValid()
                .then(() => this.$emit('load', true))
                .then(() => this.nextStep())
                .catch((e) => {
                    switch (e.message) {
                        case 'billingcontact':
                            Push.error(
                                this.$l10n.__('Certains champs sont invalides ou incomplets'),
                                this.$l10n.__('Contact de facturation'),
                            );
                            break;
                        case 'billingaddress':
                            Push.error(
                                this.$l10n.__('Certains champs sont invalides ou incomplets'),
                                this.$l10n.__('Adresse de facturation'),
                            );
                            break;
                        default:
                            Push.error(this.errorLabel(e.message));
                            break;
                    }
                });
        },
        isValid() {
            return new Promise((resolve, reject) => {
                if (!this.isBillingContactValid) {
                    throw new Error('billingcontact');
                } else if (!this.isBillingAddressValid) {
                    throw new Error('billingaddress');
                } else if (!this.arePricingProductsCompliantAsCartItems()) {
                    throw new Error();
                }
                resolve(true);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;
.step-subcription-root {
    font-size: 14px;
}
</style>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;
.slider-free {
    .el-slider__runway,
    .el-slider__stop {
        background-color: $gray-100;
    }

    .el-slider__button-wrapper {
        display: none;
    }
}

.slider-priced,
.slider-free {
    .el-slider__marks-text {
        color: $gray-100;
    }
}

.is-max-range {
    pointer-events: none;

    .el-slider__bar {
        width: 100%;
    }

    .el-slider__button-wrapper {
        left: 100%;
    }
}
</style>
